export type Region = 'USA' | 'LATAM' | 'India' | 'EMEA';

export const REGIONS: Region[] = ['USA', 'LATAM', 'India', 'EMEA'];

export interface Contributor {
  id: string;
  name: string;
  email: string;
  region: Region;
  displayOrder?: number;
  display?: boolean; // false = hidden from viewer/editor access levels (admins/superadmins always see it)
  isOutOfOffice?: boolean;
  oooStartDate?: string; // YYYY-MM-DD
  oooEndDate?: string; // YYYY-MM-DD
  lastUpdated?: string; // ISO timestamp
}

export interface Solution {
  id: string;
  name: string;
  displayOrder?: number;
}

// Updated status meanings:
// available = Qualified and Available
// limited = Qualified not Available
// unavailable = Not Qualified
export type AvailabilityStatus = 'available' | 'limited' | 'unavailable';

// Map of contributorId -> solutionId -> status
export type AvailabilityMap = Record<string, Record<string, AvailabilityStatus>>;

// Experience levels
export type ExperienceLevel = 'L1' | 'L2' | 'L3' | 'L4';

export const EXPERIENCE_LEVELS: ExperienceLevel[] = ['L1', 'L2', 'L3', 'L4'];

export const EXPERIENCE_LABELS: Record<ExperienceLevel, string> = {
  L1: 'Foundational',
  L2: 'Intermediate',
  L3: 'Advanced',
  L4: 'Champion'
};

// Map of contributorId -> solutionId -> ExperienceLevel
export type ExperienceLevelMap = Record<string, Record<string, ExperienceLevel>>;

// --- Weekly schedule types ---

// Per-day availability overrides for one contributor: solutionId → status (sparse)
export type DaySchedule = Partial<Record<string, AvailabilityStatus>>;

// Full week schedule for one contributor: YYYY-MM-DD → DaySchedule (sparse)
export type ContributorWeekSchedule = Record<string, DaySchedule>;

// Payload returned by db-get-current-week-schedule / db-get-next-week-schedule
export interface WeekSchedulePayload {
  contributorId: string;
  weekKey: string;    // e.g. "2026-W25"
  weekStart: string;  // YYYY-MM-DD (Monday)
  weekEnd: string;    // YYYY-MM-DD (Sunday)
  schedule: ContributorWeekSchedule;
}

// Map of contributorId → today's day schedule, returned by db-get-state
// Used to apply weekly overrides at highest priority in the today view
export type WeeklyScheduleToday = Record<string, DaySchedule>;
